import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { HplcTransferCalc } from "../components/HplcTransferCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.hplc_tool_name()}
        toolPath="/hplc-method-transfer"
      />
      <SciHeader title={m.hplc_h1()} intro={m.hplc_intro()} />
      <HplcTransferCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.hplc_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.hplc_ex1(), m.hplc_ex2(), m.hplc_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.hplc_faq_q1(), a: m.hplc_faq_a1() },
          { q: m.hplc_faq_q2(), a: m.hplc_faq_a2() },
          { q: m.hplc_faq_q3(), a: m.hplc_faq_a3() },
          { q: m.hplc_faq_q4(), a: m.hplc_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
